import TestImg from "./test_img.jpg";

export default TestImg;
